/**
 * Client-side PII API module — replaces pii.actions.ts Server Actions.
 */

import { PII } from "@/shared/constants/backend-api"
import { authFetchJson } from "@/shared/lib/auth-fetch"
import { ApiResponse } from "@/shared/types/backend-response.type"

export type RevealPiiResponse = {
  field: string
  value: string | null
}

/**
 * Reveal an unmasked Tier 2 PII field for a volunteer.
 *
 * @param volunteerId - The volunteer's ID (from volunteer record, not user ID)
 * @param fieldName - The PII field name to reveal (e.g. 'passportNumber', 'dateOfBirth')
 */
export async function revealPiiField(
  volunteerId: number,
  fieldName: string,
): Promise<ApiResponse<RevealPiiResponse>> {
  return authFetchJson<RevealPiiResponse>(PII.reveal(volunteerId, fieldName))
}
